import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "title", "caption", "options", "defaultValue", "name", "required", "readOnly", "forbidChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { forwardRef, useState, useCallback } from "react";
import classnames from "classnames";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RadioField = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      error,
      className,
      title,
      caption,
      options,
      defaultValue,
      name,
      required,
      readOnly,
      forbidChange
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  const {
    0: selected,
    1: setSelected
  } = useState(defaultValue);
  const handleChange = useCallback(e => {
    setSelected(e.target.value);
  }, []);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.inputField,
    children: [title && /*#__PURE__*/_jsx("legend", {
      className: classnames(styles.formTitle, {
        [styles.required]: required,
        [styles.forbidChange]: forbidChange
      }),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.formGroup,
      children: options.map((option, i) => /*#__PURE__*/_jsxs("div", {
        className: classnames(styles.inputField, styles.radio, {
          [styles.readOnly]: readOnly
        }),
        children: [/*#__PURE__*/_jsx("input", _objectSpread({
          ref: ref,
          type: "radio",
          name: name,
          id: `${name}-${option.value}`,
          className: classnames(styles.radioInput, className),
          value: option.value,
          onChange: handleChange,
          checked: selected == option.value
        }, _props)), /*#__PURE__*/_jsx("label", {
          htmlFor: `${name}-${option.value}`,
          tabIndex: "0",
          children: option.label
        })]
      }, `radio-${i}`))
    }), caption && /*#__PURE__*/_jsx("p", {
      className: styles.caption,
      children: caption
    }), error && /*#__PURE__*/_jsx("span", {
      className: styles.errorMessage,
      children: error
    })]
  });
});
RadioField.displayName = "RadioField";
export default RadioField;